import { createSelector } from 'reselect';

const selectProducts = (state: any) => state.products;

export const selectProductsCurrentItem = createSelector([selectProducts], (products) => products.current);

export const selectProductsListItems = createSelector([selectProducts], (products) => products.list);


export const selectProductsItemById = (itemId: any) =>
    createSelector(selectProductsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductsQueryItems = createSelector([selectProducts], (products) => products.query);

export const selectProductsCreatedItem = createSelector([selectProducts], (products) => products.create);

export const selectProductsUpdatedItem = createSelector([selectProducts], (products) => products.update);

export const selectProductsReadItem = createSelector([selectProducts], (products) => products.read);

export const selectProductsDeletedItem = createSelector([selectProducts], (products) => products.delete);

export const selectProductsSearchedItems = createSelector([selectProducts], (products) => products.search);

export const selectProductsItemsCount = createSelector([selectProducts], (products) => products.count);

export const selectProductsItemsFilter = createSelector([selectProducts], (products) => products.filter);